export const ALL_PRODUCT_REQUEST = "ALL_PRODUCT_REQUEST"
export const ALL_PRODUCT_SUCCESS = "ALL_PRODUCT_SUCCESS"
export const ALL_PRODUCT_FAIL = "ALL_PRODUCT_FAIL"
export const CLEAR_ALL_ERRORS = "CLEAR_ALL_ERRORS"


export const PRODUCT_DETAIL_REQUEST = "PRODUCT_DETAIL_REQUEST"
export const PRODUCT_DETAIL_SUCCESS = "PRODUCT_DETAIL_SUCCESS"
export const PRODUCT_DETAIL_FAIL = "PRODUCT_DETAIL_FAIL"


export const PRODUCT_REVIEW_REQUEST = "PRODUCT_REVIEW_REQUEST"
export const PRODUCT_REVIEW_SUCCESS = "PRODUCT_REVIEW_SUCCESS"
export const PRODUCT_REVIEW_FAIL = "PRODUCT_REVIEW_FAIL"

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST"
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS"
export const PRODUCT_UPDATE_FAIL = "PRODUCT_UPDATE_FAIL"

